var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorGood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.5,
    height: 18.701,
    viewBox: "0 0 18.5 18.701",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9500",
    "data-name": "Group 9500",
    transform: "translate(-1491.71 -933.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7518",
    "data-name": "Path 7518",
    d: "M1533.1,967.764h-7.815v8.518h7.815a.6.6,0,0,0,.6-.6v-7.314A.6.6,0,0,0,1533.1,967.764Z",
    transform: "translate(-23.491 -23.727)",
    fill: "#5475c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7519",
    "data-name": "Path 7519",
    d: "M1491.71,968.366v7.314a.6.6,0,0,0,.6.6h7.815v-8.518h-7.815A.6.6,0,0,0,1491.71,968.366Z",
    transform: "translate(0 -23.727)",
    fill: "#5475c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7520",
    "data-name": "Path 7520",
    d: "M1505.523,942.373h9.368a.6.6,0,0,0,.6-.6v-7.314a.6.6,0,0,0-.6-.6h-3.852v3.5a.832.832,0,0,1-1.665,0v-3.5h-3.852a.6.6,0,0,0-.6.6v7.314A.6.6,0,0,0,1505.523,942.373Z",
    transform: "translate(-9.243)",
    fill: "#5475c2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorGood);
export default __webpack_public_path__ + "static/media/color_good.ac68211b40d3188047b4ea11e6f97e0f.svg";
export { ForwardRef as ReactComponent };